import React from 'react';
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { Trash2 } from 'lucide-react';
import { JobPosting } from './types';

interface DeleteConfirmationDialogProps {
  isOpen: boolean;
  job: JobPosting | null;
  applicationCount: number;
  onConfirm: () => void;
  onCancel: () => void;
}

const DeleteConfirmationDialog: React.FC<DeleteConfirmationDialogProps> = ({
  isOpen,
  job,
  applicationCount,
  onConfirm,
  onCancel
}) => {
  if (!job) return null;

  return (
    <Dialog open={isOpen} onOpenChange={onCancel}>
      <DialogContent className="max-w-md">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2 text-destructive">
            <Trash2 className="h-5 w-5" />
            Delete Job Posting
          </DialogTitle>
          <DialogDescription>
            Are you sure you want to delete "{job.title}"?
          </DialogDescription>
        </DialogHeader>
        <div className="py-4">
          <div className="bg-destructive/10 border border-destructive/20 rounded-lg p-4">
            <p className="text-sm text-destructive font-medium mb-2">This action cannot be undone.</p>
            <ul className="text-sm text-muted-foreground space-y-1">
              <li>• The job posting will be permanently deleted</li>
              <li>• All {applicationCount} associated applications will be deleted</li>
              <li>• QR codes linking to this job will no longer work</li>
            </ul>
          </div>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={onCancel}>
            Cancel
          </Button>
          <Button variant="destructive" onClick={onConfirm}>
            <Trash2 className="h-4 w-4 mr-2" />
            Delete Job Posting
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default DeleteConfirmationDialog;